// Enhanced bank data with more detailed information
export const bankData = {
  akbank: {
    name: 'Akbank',
    logo: 'https://cdn.hangikredi.com/images/bankdigitalonboarding/a80c0972-6830-4dc4-b3bc-e236c7fbb5ea.png',
    color: 'red',
    stats: {
      customers: '19M+',
      branches: '700+',
      atmCount: '5400+',
      founded: '1948'
    },
    products: {
      credits: [
        {
          title: 'İhtiyaç Kredisi',
          rate: '3.99',
          term: '36',
          amount: '500.000',
          features: ['Masrafsız kullanım', 'Anında onay', '3 ay erteleme'],
          benefits: [
            'Kredi tutarı 500.000 TL\'ye kadar',
            '36 aya varan vade seçenekleri',
            'İlk 3 ay ödemesiz dönem',
            'Dosya masrafı yok'
          ],
          requirements: [
            'T.C. vatandaşı olmak',
            '18 yaşını doldurmuş olmak',
            'Düzenli gelir sahibi olmak'
          ],
          documents: [
            'Nüfus cüzdanı',
            'Gelir belgesi',
            'İkametgah'
          ]
        },
        {
          title: 'Konut Kredisi',
          rate: '2.99',
          term: '120',
          amount: '10.000.000',
          features: ['%90 finansman', 'Ekspertiz indirimi', 'Masraf avantajı'],
          benefits: [
            '10 yıla varan vade seçenekleri',
            'Evin değerinin %90\'ına kadar kredi',
            'Ücretsiz ekspertiz hizmeti',
            'Özel sigorta indirimleri'
          ],
          requirements: [
            'T.C. vatandaşı olmak',
            '18 yaşını doldurmuş olmak',
            'Düzenli gelir sahibi olmak'
          ],
          documents: [
            'Nüfus cüzdanı',
            'Gelir belgesi',
            'Tapu fotokopisi',
            'İkametgah'
          ]
        },
        {
          title: 'Taşıt Kredisi',
          rate: '3.49',
          term: '48',
          amount: '1.000.000',
          features: ['Hızlı onay', 'Kasko indirimi', 'Esnek ödeme'],
          benefits: [
            '48 aya varan vade seçenekleri',
            'Araç değerinin %70\'ine kadar kredi',
            'Özel kasko indirimleri',
            'Esnek ödeme planı'
          ],
          requirements: [
            'T.C. vatandaşı olmak',
            '18 yaşını doldurmuş olmak',
            'Düzenli gelir sahibi olmak'
          ],
          documents: [
            'Nüfus cüzdanı',
            'Gelir belgesi',
            'Araç ruhsatı',
            'İkametgah'
          ]
        }
      ],
      cards: [
        {
          title: 'Axess',
          type: 'Kredi Kartı',
          image: 'https://images.unsplash.com/photo-1614623658831-61644f04e316?auto=format&fit=crop&q=80&w=500&h=300',
          features: ['Chip-para kazanımı', 'Taksit avantajları', 'Ücretsiz ek kart'],
          benefits: [
            'Her alışverişte %1 chip-para',
            'Anlaşmalı markalarda 12 taksit',
            '5 adete kadar ücretsiz ek kart',
            'Yurt dışı alışverişlerde ekstra puan'
          ],
          fees: {
            annual: '350 TL',
            extraCard: 'Ücretsiz',
            virtualCard: 'Ücretsiz'
          },
          limits: {
            min: '1.000 TL',
            max: '50.000 TL'
          }
        },
        {
          title: 'Wings',
          type: 'Kredi Kartı',
          image: 'https://images.unsplash.com/photo-1511938736117-4b485e52c9bb?auto=format&fit=crop&q=80&w=500&h=300',
          features: ['Mil kazanımı', 'Lounge erişimi', 'Seyahat sigortası'],
          benefits: [
            'Her 1 TL harcamaya 1 mil',
            'Yılda 6 kez ücretsiz lounge',
            'Kapsamlı seyahat sigortası',
            'Havalimanı transfer indirimi'
          ],
          fees: {
            annual: '450 TL',
            extraCard: '225 TL',
            virtualCard: 'Ücretsiz'
          },
          limits: {
            min: '5.000 TL',
            max: '100.000 TL'
          }
        }
      ],
      deposits: [
        {
          title: 'e-Mevduat',
          rate: '45',
          term: '32',
          features: ['Günlük faiz', 'Vade sonu bekleme yok', 'Online işlem'],
          benefits: [
            'Günlük faiz kazancı',
            'Vade sonunda otomatik yenileme',
            'İnternet bankacılığından kolay açılış',
            'Esnek vade seçenekleri'
          ],
          requirements: [
            'T.C. vatandaşı olmak',
            '18 yaşını doldurmuş olmak',
            'Akbank müşterisi olmak'
          ],
          limits: {
            min: '1.000 TL',
            max: 'Limitsiz'
          }
        },
        {
          title: 'Döviz Mevduatı',
          rate: '5.25',
          term: '32',
          features: ['USD/EUR seçeneği', 'Vade sonunda TL\'ye çevirme', 'Online işlem'],
          benefits: [
            'Döviz kurunda yükselme beklentisi',
            'Vade sonunda TL\'ye çevirme imkanı',
            'İnternet bankacılığından kolay açılış',
            'Esnek vade seçenekleri'
          ],
          requirements: [
            'T.C. vatandaşı olmak',
            '18 yaşını doldurmuş olmak',
            'Akbank müşterisi olmak'
          ],
          limits: {
            min: '100 USD/EUR',
            max: 'Limitsiz'
          }
        }
      ]
    },
    campaigns: [
      {
        title: 'Yeni Müşteri Kampanyası',
        description: 'İlk kredi kartınıza 1.000 TL chip-para hediye!',
        endDate: '31.12.2024',
        conditions: [
          'İlk kez Akbank kredi kartı alacak müşteriler için geçerlidir',
          'Chip-para 3 ay içinde kullanılmalıdır',
          'Nakit çekim ve e-ticarette geçerli değildir'
        ]
      },
      {
        title: 'Hoş Geldin Kredisi',
        description: '%0 faizli 10.000 TL kredi fırsatı',
        endDate: '31.12.2024',
        conditions: [
          'İlk kez Akbank müşterisi olacaklar için geçerlidir',
          '3 ay vade ile kullanılabilir',
          'Kredi notu 1500 ve üzeri olan müşteriler için geçerlidir'
        ]
      }
    ],
    digitalFeatures: [
      {
        title: 'Akbank Mobil',
        description: '7/24 mobil bankacılık işlemleri',
        icon: 'Smartphone'
      },
      {
        title: 'QR ile Ödeme',
        description: 'Temassız, hızlı ödeme',
        icon: 'QrCode'
      },
      {
        title: 'Dijital Cüzdan',
        description: 'Tüm kartlarınız tek uygulamada',
        icon: 'Wallet'
      }
    ]
  }
  // Add other banks here...
};

export type BankData = typeof bankData;
export type BankId = keyof BankData;